import { parseISO } from "date-fns";
import {
  USERS_ME_ENDPOINT,
  PUBLIC_USERS_ENDPOINT,
  UPDATE_AVATAR_OPERATION,
} from "@/common/constants";
import {
  User,
  UserKind,
  UserResponse,
  UserStatus,
  UserForm,
  UserInfoRequest,
  UserNotificationSettings,
} from "@/common/models/user";
import axios from "@/common/services/axios";
import { logout } from "@/common/services/auth.service";

const processUser = (raw: UserResponse): User => ({
  id: raw.id,
  role: raw.role,
  name: raw.name,
  surname: raw.surname,
  email: raw.email,
  alias: raw.alias,
  birthday: raw.birthday,
  phone: raw.phone,
  avatar: raw.avatar,
  karma: raw.karma,
  account: {
    kind: raw.account.kind as UserKind,
  },
  settings: raw.settings,
  status: raw.status as UserStatus,
  groups: [],
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

const processInfoUser = (data: UserForm): Partial<UserInfoRequest> => ({
  name: data.name,
  surname: data.surname,
  alias: data.alias,
  birthday: data.birthday,
  phone: data.phone,
});

export const fetchMe = async (): Promise<User> => {
  const { data } = await axios.get<UserResponse>(`${USERS_ME_ENDPOINT}`);
  return processUser(data);
};

export const filterUserByAlias = async (value: string): Promise<User[] | undefined> => {
  try {
    const { data } = await axios.get<User[]>(
      `${PUBLIC_USERS_ENDPOINT}?q=alias+like+"*${value}*(?i)"&orderBy=alias`,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
  return;
};

export const editInfoUser = async (user: UserForm): Promise<Partial<User>> => {
  if (user.avatar) {
    const formData = new FormData();
    formData.append("file", user.avatar);
    await axios.post<UserResponse>(`${USERS_ME_ENDPOINT}${UPDATE_AVATAR_OPERATION}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  const userDTO = processInfoUser(user);
  const { data } = await axios.put<UserResponse>(`${USERS_ME_ENDPOINT}`, userDTO);
  return processUser(data);
};

export const updateUserNotificationSettings = async (
  notifications: UserNotificationSettings,
): Promise<User> => {
  await axios.post(`${USERS_ME_ENDPOINT}:updateSettings`, {
    notifications,
  });
  return fetchMe();
};

export const logOut = async (): Promise<void> => {
  try {
    logout();
  } catch (error) {
    console.error(error);
  }
};
